import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'https://airmaxxapp.com';

const api = axios.create({
  baseURL: `${API_BASE}/api/v1`,
  withCredentials: false,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('stats_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('stats_token');
      localStorage.removeItem('stats_user');
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

export const authApi = {
  login: (email, password) => api.post('/auth/login', { email, password }),
  verify2fa: (tempToken, userId, token) => api.post('/auth/verify-2fa', { tempToken, userId, token }),
  getUserInfo: () => api.get('/auth/userInfo'),
};

export const statsApi = {
  getSummary: (params) => api.get('/proposal/stats', { params }),
  getBySalesman: (params) => api.get('/proposal/stats/by-salesman', { params }),
  getTimeline: (params) => api.get('/proposal/stats/timeline', { params }),
};

export const marketingApi = {
  getAttribution: (params) => api.get('/marketing/attribution', { params }),
  getSpend: () => api.get('/marketing/spend'),
  saveSpend: (data) => api.post('/marketing/spend', data),
  getSources: () => api.get('/appointmentSource?skip=0&take=100000&sort=id,asc'),
};

export default api;
